module.exports = __webpack_public_path__ + "img/SelfAdhesive1.504f87f3.jpg";